import { ITrademarkStatisticsQuery } from "../../models/statistcs-trademark/query";
import { IStatistics } from "../../models/statistcs/respons";
import { ITrademarkStatistics } from "../../models/trademark-statistics/respons";
import { HttpClient, RequestParams } from "../../utils/api/http-client";

class TrademarkStatisticsService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getTrademarkStatisticsStatistics = (query: ITrademarkStatisticsQuery,params?: RequestParams) =>
    this.http.request<ITrademarkStatistics>({
      path: `/trademark_statistic`,
      method: "GET",
      query,
      ...params,
    });
}

export default TrademarkStatisticsService;


